var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228,
    height: 60,
    viewBox: "0 0 228 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_179889",
    "data-name": "Group 179889",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179145",
    "data-name": "Group 179145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6641",
    "data-name": "Rectangle 6641",
    fill: "#fff",
    stroke: "#e1e1e1",
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 40,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 227,
    height: 39,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_25",
    "data-name": "Polygon 25",
    transform: "translate(105 12)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.667,0l8.667,6.111L14.023,16H3.31L0,6.111Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.666666984558105 2.447259902954102 L 2.369093894958496 6.888108253479004 L 4.749937057495117 14 L 12.58339691162109 14 L 14.96424102783203 6.888108253479004 L 8.666666984558105 2.447259902954102 M 8.666666984558105 0 L 17.33333778381348 6.111459732055664 L 14.02295684814453 16 L 3.31037712097168 16 L -3.814697265625e-06 6.111459732055664 L 8.666666984558105 0 Z",
    stroke: "none",
    fill: "#1e1e1e"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Polygon",
    transform: "translate(0 -10)",
    fill: "#54565c",
    fontSize: 10,
    fontFamily: "NunitoSans-Regular, Nunito Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Polygon")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.4fb950e9c837b73ada19688ac0cfd835.svg";
export { ForwardRef as ReactComponent };